var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer",attrs:{"id":"footer"}},[_vm._v("\n\t© Smart Claim Systems 2021. Version "+_vm._s(_vm.version)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }